import { React } from "react";
const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <>
            <div className="main-footer">
            <p><i className="fa fa-copyright"></i> Copyright {currentYear} LFCOIN.io, All rights Reserved.</p>
            </div>
        </>
    )
}

export default Footer;